import React, { useEffect, useRef } from 'react';
import styles from './Time.module.css';
import { Player } from '@lordicon/react';
import cold from "../../icons/wired-outline-2489-ice-cube-hover-pinch (1).json";
import course from "../../icons/wired-outline-61-camera-hover-flash (1).json";
import coins from "../../icons/wired-outline-36-bulb-hover-blink.json";
import vip from "../../icons/wired-outline-950-attract-customers-hover-pinch.json";
import tadmit from "../../icons/wired-outline-2887-arrow-up-sale-hover-pinch (1).json";
import training from "../../icons/wired-outline-99-price-tag-empty-hover-flutter.json";
import book from "../../icons/wired-outline-962-social-media-marketing-hover-pinch (2).json";
import online from "../../icons/wired-outline-2610-lead-generation-hover-pinch (1).json";
import value from "../../icons/wired-outline-724-diamond-luxury-precious-hover-pinch.json"
const WhoDoesList = ({ isDarkMode }) => {
  const playerRefs = {
    course: useRef(null),
    launch: useRef(null),
    price: useRef(null),
    image: useRef(null),
    marketing: useRef(null),
    brand: useRef(null),
    digital: useRef(null),
    value: useRef(null),
    extra: useRef(null),
  };

  const icons = {
    course: training,
    launch: book,
    price: coins,
    brand: tadmit,
    digital: online,
    marketing: vip,
    image: cold,
    value: course,
    extra: value,
  };

  const handleComplete = (ref) => {
    setTimeout(() => {
      ref?.current?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    // Play all animations on initial load
    Object.values(playerRefs).forEach((ref) => {
      ref?.current?.playFromBeginning();
    });

    // Set up Intersection Observer for scroll reveal animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all items that should have reveal animation
    const revealables = document.querySelectorAll(`.${styles.needsItemWrapper}`);
    revealables.forEach((el) => observer.observe(el));

    // Clean up observer on component unmount
    return () => observer.disconnect();
  }, []);

  const texts = [
    'השאלה הראשונה שפונים אליכם איתה היא: "כמה זה עולה?" במקום "איך מצטרפים?"',
    "אתם מרגישים שהתוכן לא משקף את איכות השירות והמקצועיות שלכם.",
    "יש רעיונות, אבל בפועל התוכן עולה לעיתים רחוקות - ולא מביא פניות איכותיות.",
    'לקוחות מגיעים "קרים" ומתייחסים אליכם כאופציה, לא כברירה ברורה.',
    "אתם רוצים לעבוד עם לקוחות שמבינים ערך - ולא מתמקחים על מחיר.",
    "מתכננים להעלות מחירים / למכור פרימיום - אבל התוכן לא מחזיק את זה עדיין.",
    "רוצים לדעת מה להגיד, למי ואיך - כדי שתוכן יביא לקוחות, לא רק חשיפות.",
    "מצלמה גורמת לכם להיתקע או לגמגם - ואתם יודעים שאם יכוונו אתכם, משהו יזוז שם.",
    "מרגישים שיש לכם הרבה יותר לתת - אבל הקהל עדיין לא באמת קולט את הערך.",
  ];

  const keys = Object.keys(playerRefs);

  return (
    <div className={styles.needsContainer}>
      <div className={styles.needsList}>
        {texts.map((text, i) => (
          <div className={styles.needsItemWrapper} key={i}>
            <div className={styles.needsItem}>
              <div className={styles.iconWrapper}>
                <Player
                  icon={icons[keys[i]]}
                  ref={playerRefs[keys[i]]}
                  size="100%"
                  loop={true}
                  onComplete={() => handleComplete(playerRefs[keys[i]])}
                />
              </div>
              <div className={styles.itemContent}>
                <p className={styles.itemText}>{text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhoDoesList;